import { render } from "./testdataexporteditor.vue?vue&type=template&id=2716a0a1"
import script from "./testdataexporteditor.vue?vue&type=script&lang=js"
export * from "./testdataexporteditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__